export default __webpack_public_path__ + "static/media/estate.7b1de603.png";